// extracted by mini-css-extract-plugin
export default {"switch":"UnitPreference-module--switch--c81ba","label":"UnitPreference-module--label--6edfc"};